import EmployeesCom from "../components/EmployeesCom";

function Employees() {
  return (
    <EmployeesCom type="active"/>
  );
}

export default Employees;